var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06459 1.47472C7.39038 0.612815 8.60962 0.612816 8.93541 1.47472L10.2541 4.96355C10.3951 5.33647 10.7441 5.59004 11.1423 5.60886L14.8679 5.78494C15.7883 5.82843 16.1651 6.988 15.446 7.56419L12.5355 9.89647C12.2243 10.1458 12.091 10.5561 12.1962 10.9406L13.18 14.5383C13.4231 15.427 12.4367 16.1437 11.6665 15.6379L8.54894 13.5905C8.2157 13.3717 7.7843 13.3717 7.45106 13.5905L4.33351 15.6379C3.56333 16.1437 2.57694 15.427 2.81999 14.5383L3.8038 10.9406C3.90896 10.5561 3.77565 10.1458 3.46454 9.89647L0.553979 7.56419C-0.165069 6.988 0.211697 5.82843 1.13209 5.78494L4.85767 5.60886C5.2559 5.59004 5.60491 5.33647 5.74587 4.96355L7.06459 1.47472Z",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/EmptyStar.72d7a3c7215fc14144188741e51ff740.svg";
export { ForwardRef as ReactComponent };